import { PostBodyUrl, SimpleUrl, UrlWithId } from 'interfaces/ajax/base'
import {
  CCAutoPayment,
  CCCreateAutoPaymentApiRequest,
  CCCreatePaymentApiRequest,
  CCOneTimePayment,
  CCPaymentsApiResponse,
  CCReplaceReason,
  CCUpcomingPaymentsApiResponse,
} from 'components/features/creditCard/creditCardStore/types'
import {
  CCOnboardingPatchApiRequest,
  CCDetailedOnboardingStateApiResponse,
  CCOnboardingStateApiResponse,
  CCPaymentMethodsApiResponse,
  CCBaseApiResponse,
  CCActivationApiRequest,
  CCUid,
  CCCreatePaymentMethodApiRequest,
  CCPaymentMethod,
} from 'components/features/creditCard/creditCardStore/types'

export const CC_JOIN_WAITLIST_URL = '/api/v1/credit-card/waitlist/join/' as const
export const CC_STATE_URL = '/api/v1/credit-card/state/' as const
export const CC_ONBOARDING_URL = '/api/v1/credit-card/onboarding/' as const
export const CC_ONBOARDING_INITIATE_URL = '/api/v1/credit-card/onboarding/initiate/' as const
export const CC_ONBOARDING_ACCEPT_OFFER_URL = '/api/v1/credit-card/onboarding/accept-offer/' as const

export const CC_ONBOARDING_PHONE_CREATE_URL = '/api/v1/credit-card/phone/create/' as const
export const CC_ONBOARDING_PHONE_VERIFY_URL = '/api/v1/credit-card/phone/verify/' as const

export const CC_PAYMENT_METHODS_URL = ' /api/v1/credit-card/payment-methods/' as const
export const CC_PAYMENT_METHODS_CREATE_URL = ' /api/v1/credit-card/payment-methods/create/' as const
export const CC_PAYMENT_METHODS_DELETE_URL = ' /api/v1/credit-card/payment-methods/:uid/delete/' as const

export const CC_PAYMENTS_URL = ' /api/v1/credit-card/payments/transactions/' as const
export const CC_UPCOMING_PAYMENTS_URL = ' /api/v1/credit-card/payments/upcoming/' as const
export const CC_PAYMENT_CREATE_URL = ' /api/v1/credit-card/payments/one-time/create/' as const
export const CC_PAYMENT_DELETE_URL = ' /api/v1/credit-card/payments/one-time/:uid/delete/' as const
export const CC_AUTO_PAYMENT_CREATE_URL = ' /api/v1/credit-card/payments/auto-pay/create/' as const
export const CC_AUTO_PAYMENT_DELETE_URL = ' /api/v1/credit-card/payments/auto-pay/delete/' as const

export const CC_REPLACE_URL = '/api/v1/credit-card/cards/:uid/replace/' as const
export const CC_EXTERNAL_ACTIVATE_URL = '/api/v1/credit-card/cards/activate/' as const
export const CC_ACTIVATE_URL = '/api/v1/credit-card/cards/:uid/activate/' as const
export const CC_LOCK_URL = '/api/v1/credit-card/cards/:uid/suspend/' as const

export const CC_DETAILS_IFRAME_URL = '/api/v1/credit-card/cards/' as const

export type PhoneCreateApiRequest = {
  phone_number: string
}

export type PhoneVerifyApiRequest = {
  phone_number: string
  verification_code: string
}
export type PhoneVerifyApiResponse = {
  phone_number: string
  is_verified: boolean
}

export type CreditCardGetEndpoints =
  & SimpleUrl<typeof CC_STATE_URL, CCOnboardingStateApiResponse>
  & SimpleUrl<typeof CC_PAYMENT_METHODS_URL, CCPaymentMethodsApiResponse>
  & SimpleUrl<typeof CC_PAYMENTS_URL, CCPaymentsApiResponse>
  & SimpleUrl<typeof CC_UPCOMING_PAYMENTS_URL, CCUpcomingPaymentsApiResponse>
  & SimpleUrl<typeof CC_ONBOARDING_URL, CCDetailedOnboardingStateApiResponse>

export type CreditCardPostEndpoints =
  & PostBodyUrl<typeof CC_JOIN_WAITLIST_URL, {}, {}>
  & PostBodyUrl<typeof CC_ONBOARDING_INITIATE_URL, {}, CCDetailedOnboardingStateApiResponse>
  & PostBodyUrl<typeof CC_ONBOARDING_ACCEPT_OFFER_URL, {}, CCDetailedOnboardingStateApiResponse>
  & PostBodyUrl<typeof CC_ONBOARDING_PHONE_CREATE_URL, PhoneCreateApiRequest, PhoneVerifyApiResponse>
  & PostBodyUrl<typeof CC_ONBOARDING_PHONE_VERIFY_URL, PhoneVerifyApiRequest, PhoneVerifyApiResponse>
  & PostBodyUrl<typeof CC_EXTERNAL_ACTIVATE_URL, CCActivationApiRequest, CCBaseApiResponse>
  & PostBodyUrl<typeof CC_PAYMENT_METHODS_CREATE_URL, CCCreatePaymentMethodApiRequest, CCPaymentMethod>
  & PostBodyUrl<typeof CC_PAYMENT_CREATE_URL, CCCreatePaymentApiRequest, CCOneTimePayment>
  & PostBodyUrl<typeof CC_AUTO_PAYMENT_CREATE_URL, CCCreateAutoPaymentApiRequest, CCAutoPayment>
  & PostBodyUrl<{ url: typeof CC_REPLACE_URL, params: { uid: CCUid } }, { reason: CCReplaceReason }, CCBaseApiResponse>
  & PostBodyUrl<{ url: typeof CC_ACTIVATE_URL, params: { uid: CCUid } }, {}, CCBaseApiResponse>
  & PostBodyUrl<{ url: typeof CC_LOCK_URL, params: { uid: CCUid } }, {}, CCBaseApiResponse>
  & SimpleUrl<typeof CC_AUTO_PAYMENT_DELETE_URL, {}>
  & SimpleUrl<UrlWithId<typeof CC_PAYMENT_METHODS_DELETE_URL>, {}>
  & SimpleUrl<UrlWithId<typeof CC_PAYMENT_DELETE_URL>, {}>

export type CreditCardPatchEndpoints =
  & PostBodyUrl<typeof CC_ONBOARDING_URL, CCOnboardingPatchApiRequest, CCDetailedOnboardingStateApiResponse>
